import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckSquare } from "lucide-react";

interface LiffCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export default function LiffCheckbox({
  checked,
  onCheckedChange,
}: LiffCheckboxProps) {
  return (
    <CheckboxPrimitive.Root
      checked={checked}
      onCheckedChange={(value) => onCheckedChange(value === true)}
      className={`mt-1 flex size-5 ${checked ? null : "bg-[#D9D9D9]"}`}
    >
      <CheckboxPrimitive.Indicator className="flex items-center justify-center">
        <CheckSquare size={22} strokeWidth={1} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}
